'use client'

// src/components/product/sections/organization/MatchItemLoader.tsx
import { Paper } from "@wbk/ui";
import { twMerge } from "tailwind-merge";
import { jsx } from "react/jsx-runtime";
var MatchItemLoader = ({ className }) => {
  return [1, 2].map((i) => /* @__PURE__ */ jsx(Paper, { className: twMerge("animate-pulse", className), surface: "level-1", border: false, children: /* @__PURE__ */ jsx("div", {}) }, i));
};
var MatchItemLoader_default = MatchItemLoader;

export {
  MatchItemLoader_default
};
//# sourceMappingURL=chunk-VIN62BPX.mjs.map